import React, { useState, lazy, Suspense, useEffect } from "react";

import clsx from "clsx";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import LockIcon from '@material-ui/icons/Lock';
import { useUserDispatch, signOut } from "../../context/UserContext";
import { Table, Empty, Dropdown, Menu } from "antd";
import {
    Route,
    Switch,
    Redirect,
    useLocation,
    NavLink,
    useHistory,
} from "react-router-dom";
import Idletimer from "./../Common/Idletimer";
import IdleTimerPoper from "./poper/IdleTimerPoper";
import PressReleaseIcon from "../../assets/img/icons/pressReleaseIcon.svg";
import DistributionListIcon from "../../assets/img/icons/distributionList.svg";
import AgencyListIcon from "../../assets/img/icons/agencyList.svg";
import DashboardSanta from "../../assets/img/icons/dashboardSanta.svg";
import DashboardPalmBeach from "../../assets/img/icons/TabletPalmBeach.svg"
import TabletFloridaConnect from "../../assets/img/icons/TabletFloridaConnect.svg"
import { useMediaQuery } from 'react-responsive';
import SocialWorker from "../../pages/socialWorker/SocialWorker";
import SocialWorkerIcon from '../../assets/img/icons/SocialWorker.svg';
import DateRangeIcon from "@material-ui/icons/DateRange";
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import FeedingFamily from "../../pages/feedingFamily/FeedingFamily";
import FloridaConnectApplicant from "../../pages/floridaConnect/ApplicantLogs";

import {
    Drawer,
    Badge,
    Box,
    AppBar,
    Toolbar,
    List,
    IconButton,
    ListItem,
    Collapse,
    Button,
    Tooltip,
} from "@material-ui/core";

import Dashboard from "./../../pages/dashboard/Dashboard";
import DonationDetails from "../../pages/donationDetails/DonationDetails";

import CircularProgress from "@material-ui/core/CircularProgress";
import MenuIcon from "@material-ui/icons/Menu";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MessagesIcon from "../../assets/img/icons/Messages.svg";

import DashboardIcon from "../../assets/img/icons/dashboardIcon.svg";

import GrantDashboardIcon from "../../assets/img/icons/Icons_Dashboard.svg";
import GrantProgramIcon from "../../assets/img/icons/Icons_Program.svg";
import GrantOrganizationIcon from "../../assets/img/icons/Icons_Organization.svg";
import GrantDisbursementIcon from "../../assets/img/icons/Icons_Disbursement.svg";
import DashboardGrantIcon from "../../assets/img/icons/DashboardGrantIcon.svg";

import Logo from "../../assets/img/Figger-foundation-logo.svg";
import DashboardOrderTracking from "../../assets/img/icons/DashboardOrderTracking.svg";

import InternationalTracking from "../../assets/img/shop/internationalTracking.svg";
import ReturnLab from "../../assets/img/shop/ReturnLab.svg";
import VoiceCallLogsIcon from "../../assets/img/shop/VoiceCallLogsIcon.svg";

import ReviewsIcon from "../../assets/img/icons/DashboardReviewsIcon.svg";
import Notification from "../../assets/img/icons/Notification.svg";

import commentsIcons from "../../assets/img/icons/DashboardCommunicationIcon.svg";
import ForumIcon from '@material-ui/icons/Forum';
import DashboardOfficeIcon from "../../assets/img/icons/DashboardOfficeIcon.svg";
import TabletAndroidIcon from "@material-ui/icons/TabletAndroid";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import LogoSm from "../../assets/img/logo-sm.svg";
import SettingsIcon from "../../assets/img/icons/setting.svg";
import Reviews from "../../pages/reviews/Reviews";

import DonationRequest from "../../pages/donationRequest/DonationRequest";
import AddressBookPage from "../../pages/addressBook/AddressBook";
import UpdatePassword from "../../pages/updatePassword/UpdatePassword";

import SubscribersIconBlue from "../../assets/img/icons/SubscribersIconBlue.svg";
import InventionsIconBlue from "../../assets/img/icons/InventionsIconBlue.svg";
import InquiriesIconBlue from "../../assets/img/icons/InquiriesIconBlue.svg";
import Addressbook from "../../assets/img/icons/addressbook.svg";
import DamageAndRepairIconBlue from "../../assets/img/icons/DamageAndRepairIconBlue.svg";
import SmsNonCustom from "../../assets/img/icons/smsNonCustom.svg";
import AddressbookIconBlue from "../../assets/img/icons/AddressbookIconBlue.svg";
import DomesticTrackingIcon from "../../assets/img/icons/DomesticTracking.svg";

import UsageReport from "../../assets/img/icons/UsageReport.svg";
import EnrolledIcon from "../../assets/img/icons/enrolledIcon.svg";
import RejectedIcon from "../../assets/img/icons/FaildIcon.svg";

import Popover from "@material-ui/core/Popover";

import UserPlaceholder from "../../assets/img/userPlaceholder.svg";

import { PostDataAPI } from "../../Services/APIService";
import { GetUserInfo } from "../../../src/Services/GetUserInfo";
import { ActionDialog } from "../ActionDialog/ActionDialog";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import HttpsOutlinedIcon from "@material-ui/icons/HttpsOutlined";
import DomesticTracking from "../../pages/orderTracking/domesticTracking/DomesticTracking";

import VoiceCallLogs from "../../pages/orderTracking/voiceCall/VoiceCallLogs";

import SheilaTablets from "../../pages/sheilaTablets/SheilaTablets";
import PalmBeachTablets from "../../pages/palmBeachTabletsProgram/PalmBeachTablets";
import FloridaConnect from "../../pages/floridaConnect/FloridaConnect";
import FloridaConnectRepresentative from "../../pages/floridaConnect/FloridaConnectRepresentative"
import PompanoBeach from "../../pages/pompanoBeach/PompanoBeach";
import Profile from "../../pages/profile/Profile";
import EventsCalendar from "../../pages/eventCalendar/EventsCalendar";

import GrantProgram from '../../pages/grants/programs/Program';
import GrantDashboard from '../../pages/grants/dashboard/Dashboard'
import PressRelease from "../../pages/pressRelease/PressRelease";
import NewsMedia from "../../pages/newsMedia/NewsMedia";
import LetterofSupport from "../../pages/letterofSupport/LetterofSupport";
import AgencyList from "../../pages/pressRelease/agencyList/AgencyList";
import DistributerList from "../../pages/pressRelease/distributerList/DistributerList";
import Chat from "../../pages/chat/Chat";
import DeliveryIco from "../../assets/img/icons/Menudelivery.svg";
import ProposalDocuments from "../../pages/grants/programs/programDetails/proposalDocuments/ProposalDocuments"
import EveryChildChristmas from "../../pages/everyChildChristmas/everyChildChristmas";
import ECCDonations from "../../pages/everyChildChristmas/donations/DonationDetails";
import Organizations from "../../pages/grants/organization/Organization";
import Disbursement from "../../pages/grants/disbursement/Disbursement";
import Subscribers from "../../pages/subscriber/subscribers";
import AddPostAndBlogPage from "../../pages/post/Blog";




import useStyles from "./styles";
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';
import Settingwhite from '../../assets/img/icons/settingwhite.svg';
import RolesIcon from "../../assets/img/icons/roles.svg";
import UsersIcon from "../../assets/img/icons/users.svg";
import Roles from "./../../pages/setup/roles/Roles";
import Users from "./../../pages/setup/users/users";
import Rights from "../../pages/setup/rights/rights";
const SysConfig = lazy(() => import('../../pages/setup/setupConfig/SetupConfig'));
export default function Layout(props) {
    window.isMobileView = useMediaQuery({ maxWidth: '650px' });
    window.isIpadView = useMediaQuery({ maxWidth: '1024px' });
    window.max1300 = useMediaQuery({ maxWidth: '1300px' });
    window.max1550 = useMediaQuery({ maxWidth: '1550px' });
    window.max1750 = useMediaQuery({ maxWidth: '1750px' });
    const Resethistory = useHistory();
    const location = useLocation();
    const HomeHistory = useHistory();
    const [userInfo, setUserInfo] = useState(sessionStorage.getItem("user_info"));
    var user = sessionStorage.getItem("user_info");
    var userdata = JSON.parse(user)?.user;
    const [counter, setCounter] = useState(0);
    var userDispatch = useUserDispatch();
    const classes = useStyles();
    const [subMenuOpen, setSubMenuOpen] = React.useState(false);
    const [subMenuBackend, setSubMenuBackend] = React.useState(false);
    const [subFiggerACP, setSubFiggerACP] = React.useState(false);
    const [childMenu, setChildMenu] = React.useState(false);
    const [shopMenu, setShopMenu] = React.useState(false);
    const [officeMenu, setOfficeMenu] = React.useState(false);
    const [grantMenu, setGrantMenu] = React.useState(false);
    const [shippingMenu, setShippingMenu] = React.useState(false);
    const [timerPoper, setTimerPoper] = useState(false);

    const [loading, setLoading] = React.useState(true);
    const [subEveryChildChristmas, setSubEveryChildChristmas] = React.useState(false);
    const [popoverState, setPopoverState] = useState(null);
    const handlePopoverOpen1 = (event, index) => {
        setAnchorE1(event.currentTarget);
        setPopoverState(index);
    };
    const handleClickShippingMenu = () => {
        if (shippingMenu == true) {
            setShippingMenu(false);
        } else {
            setShippingMenu(true);
        }
    };

    const timerPoperOpen = () => {
        setTimerPoper(true);
    };

    const timerPoperClose = () => {
        setTimerPoper(false);
    };

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };

    const logoutUser = (item) => {
        signOut(userDispatch, props.history);
        //showActionDialog("Are you sure, you want to logout?", "confirm", function () {
        //    signOut(userDispatch, props.history)
        //});
    };

    const handleClickOfficeMenu = () => {
        if (officeMenu == true) {
            setOfficeMenu(false);
        } else {
            setOfficeMenu(true);
        }
    };

    const handleClickGrantMenu = () => {
        if (grantMenu == true) {
            setGrantMenu(false);
        } else {
            setGrantMenu(true);
        }
    };

    const handleClickshopMenu = () => {
        if (shopMenu == true) {
            setShopMenu(false);
        } else {
            setShopMenu(true);
        }
    };

    const handleClickchildMenu = () => {
        if (childMenu == true) {
            setChildMenu(false);
        } else {
            setChildMenu(true);
        }
    };

    const handleClickBackend = () => {
        if (subMenuBackend == true) {
            setSubMenuBackend(false);
        } else {
            setSubMenuBackend(true);
        }
    };

    const handleClickACP = () => {
        if (subFiggerACP == true) {
            setSubFiggerACP(false);
        } else {
            setSubFiggerACP(true);
        }
    };

    const handleClick = () => {
        if (subMenuOpen == true) {
            setSubMenuOpen(false);
        } else {
            setSubMenuOpen(true);
        }
    };
    const handleClickEveryChildChristmas = () => {
        if (subEveryChildChristmas == true) {
            setSubEveryChildChristmas(false);
        } else {
            setSubEveryChildChristmas(true);
        }
    }
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [anchorE1, setAnchorE1] = React.useState(null);
    const [anchorE2, setAnchorE2] = React.useState(null);
    const [anchorE3, setAnchorE3] = React.useState(null);
    const [anchorE4, setAnchorE4] = React.useState(null);
    const [anchorE5, setAnchorE5] = React.useState(null);
    const [anchorE6, setAnchorE6] = React.useState(null);
    const [anchorE7, setAnchorE7] = React.useState(null);

    const isPopoverOpen1 = Boolean(anchorE1);
    const isPopoverOpen2 = Boolean(anchorE2);
    const isPopoverOpen3 = Boolean(anchorE3);
    const isPopoverOpen4 = Boolean(anchorE4);
    const isPopoverOpen5 = Boolean(anchorE5);
    const isPopoverOpen6 = Boolean(anchorE6);
    const isPopoverOpen7 = Boolean(anchorE7);

    const poperClose4 = () => {
        setAnchorE4(null);
    };

    //const handlePopoverOpen1 = (event) => {
    //    setAnchorE1(event.currentTarget);
    //};
    const handlePopoverClose1 = (event) => {
        setAnchorE1(null);
    };

    const handlePopoverOpen2 = (event) => {
        setAnchorE2(event.currentTarget);
    };
    const handlePopoverClose2 = (event) => {
        setAnchorE2(null);
    };

    const handlePopoverOpen3 = (event) => {
        setAnchorE3(event.currentTarget);
    };
    const handlePopoverClose3 = (event) => {
        setAnchorE3(null);
    };

    const handlePopoverOpen4 = (event) => {
        setAnchorE4(event.currentTarget);
    };
    const handlePopoverClose4 = (event) => {
        setAnchorE4(null);
    };

    const handlePopoverOpen5 = (event) => {
        setAnchorE5(event.currentTarget);
    };
    const handlePopoverClose5 = (event) => {
        setAnchorE5(null);
    };

    const handlePopoverOpen6 = (event) => {
        setAnchorE6(event.currentTarget);
    };
    const handlePopoverClose6 = (event) => {
        setAnchorE6(null);
    };
    const handlePopoverClose7 = (event) => {
        setAnchorE7(null);
    };
    const openPoper = Boolean(anchorEl);

    const id = openPoper ? "simple-popover" : undefined;

    const poperOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const poperClose = () => {
        setAnchorEl(null);
    };

    const [open, setOpen] = React.useState(window.isMobileView ? false : true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const handlePopoverOpen7 = (event) => {
        setAnchorE7(event.currentTarget);
    };
    const counterGet = () => {
        user = sessionStorage.getItem("user_info");
        setUserInfo(sessionStorage.getItem("user_info"));
        userdata = JSON.parse(user).user;

        var params = {
            code: "unread_chat_count",
            parameters: [userdata.userID.toString()],
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                setCounter(result.data[0].t1 ? parseInt(result.data[0].t1) : 0);

                var ui = GetUserInfo();
                if (ui) {
                    startCounter();
                }
            }
        });
    };

    const logoutUserAndNavigateToResetP = () => {
        logoutUser(Resethistory.push("/app/ResetP"));
    };

    const updateShippingTrackStatus = () => {
        user = sessionStorage.getItem("user_info");
        if (user) {
            setUserInfo(sessionStorage.getItem("user_info"));
            userdata = JSON.parse(user).user;
            var params = {};
            PostDataAPI(
                "ordertracking/updateShipmentActivityStatuses",
                params,
                true
            ).then((result) => {
                var ui = GetUserInfo();
                if (ui) {
                    startShippingCounter();
                }
            });
        }
    };
    const startShippingCounter = () => {
        setTimeout(function () {
            updateShippingTrackStatus();
        }, 30000);
    };
    const startCounter = () => {
        setTimeout(function () {
            counterGet();
        }, 9000);
    };
    const [menusState, setMenusState] = React.useState([]);
    const [disabledChildren, setDisabledChildren] = React.useState([]);
    const [hiddenChildren, setHiddenChildren] = React.useState([]);
    const handleClickMenu = (name) => {
        const updatedMenu = menusState.map(obj => {
            if (obj.name === name) {
                return { ...obj, value: !obj.value }; // Toggle the value
            }
            return { ...obj, value: false };
        });
        setMenusState(updatedMenu);
    }
    useEffect(() => {
        if (user_role_rights_list != null) {
            user_role_rights_list.forEach((objright) => {
                if (objright.parentRightId === 0 && objright.permissionCode > 0) {
                    menusState.push({ name: objright.rightLabel, value: false });
                }
                if (objright.category === 'disabled' && objright.parentRightId > 0) {
                    disabledChildren.push(objright.rightLabel);
                }
                if (objright.permissionCode == 0 && objright.parentRightId > 0) {
                    hiddenChildren.push(objright.rightLabel);
                }
            });
        }
    }, []);

    const idleTimeOut = () => {
        timerPoperOpen();

        setTimeout(() => {
            // logoutUser()
        }, 20000);
    };
    // Function to handle opening the link in a new tab
    const handleLinkClick = (link) => {
        window.open(link, '_blank');
    };
    //side bar start
    const sideBarLinks = [];
    const routes = [];
    let user_role_rights_list = JSON.parse(GetUserRolesRights());

    if (user_role_rights_list != null) {
        user_role_rights_list.map((objright) => {
            if (objright.permissionCode > 0) {
                routes.push({ rightName: objright.rightName, permissionCode: objright.permissionCode, rightCode: objright.rightCode, landingPage: objright.landingPage });
            }
            if (objright.parentRightId == 0 && objright.permissionCode > 0) {

                switch (objright.rightName) {

                    case 'dashboard': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DashboardIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }

                    case 'ShippingTracking': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DashboardOrderTracking} alt='icon' />,
                                category: objright.category,
                                children: [
                                    { label: "Domestic", link: "/app/domesticTracking", icon: <img src={DomesticTrackingIcon} alt='icon' /> },
                                    { label: "International", link: "/app/" + objright.rightName.toLowerCase(), icon: <img src={InternationalTracking} alt='icon' /> },
                                    { label: "Return Label", link: "/app/returnLabel", icon: <img src={ReturnLab} alt='icon' /> },
                                    { label: "Voice Call Logs", link: "/app/voiceCallLogs", icon: <img src={VoiceCallLogsIcon} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }
                    case 'Donations': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <CardGiftcardIcon style={{ color: "white" }} />,
                                category: objright.category,
                                children: [
                                    { label: "Donations", link: "/app/donations", icon: <img src={UsageReport} alt='icon' /> },
                                    //{ label: "Donation Request", link: "/app/" + objright.rightName.toLowerCase(), icon: <img src={InternationalTracking} alt='icon' /> },
                                    { label: "Donation Request", link: "/app/donationRequest", icon: <img src={SubscribersIconBlue} alt='icon' /> },

                                ],
                            });
                        }
                        break;
                    }
                    case 'addressbook': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={Addressbook} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }

                    case 'FeedingFamily': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <CardGiftcardIcon />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'reviews': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={ReviewsIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'socialWorker': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={SocialWorkerIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    // case 'EveryChildChristmas': {

                    //     if (sideBarLinks.label != objright.rightName) {
                    //         sideBarLinks.push({
                    //             id: parseInt(objright.rightId),
                    //             label: objright.rightLabel,
                    //             link: "/app/" + objright.rightName.toLowerCase(),
                    //             icon: <img src={DashboardSanta} alt='icon' />,
                    //             category: objright.category,
                    //             children: [
                    //                 { label: "Applications", link: "/app/christmas/applications", icon: <img src={UsageReport} alt='icon' /> },
                    //                 //{ label: "Donation Request", link: "/app/" + objright.rightName.toLowerCase(), icon: <img src={InternationalTracking} alt='icon' /> },
                    //                 { label: "Donations", link: "/app/christmas/donations", icon: <CardGiftcardIcon style={{ color: "white" }} /> },

                    //             ],
                    //         });
                    //     }
                    //     break;
                    // }
                    case 'HealthCareTablet': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <TabletAndroidIcon style={{ color: "white" }} />,
                                category: objright.category,
                                children: [
                                    { label: "Request", link: "/app/sheila/request", icon: <img src={UsageReport} alt='icon' /> },
                                    { label: "Enrolled", link: "/app/sheila/enrolled", icon: <img src={EnrolledIcon} alt='icon' /> },
                                    { label: "Rejected", link: "/app/sheila/rejected", icon: <img src={RejectedIcon} alt='icon' /> },
                                    { label: "Delivered", link: "/app/sheila/delivered", icon: <img src={DeliveryIco} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }
                    case 'PalmBeachTablet': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DashboardPalmBeach} alt="icon" width="26" />,
                                category: objright.category,
                                children: [
                                    { label: "Request", link: "/app/palmBeach/request", icon: <img src={UsageReport} alt='icon' /> },
                                    { label: "Rejected", link: "/app/palmBeach/rejected", icon: <img src={RejectedIcon} alt='icon' /> },
                                    { label: "Delivered", link: "/app/palmBeach/delivered", icon: <img src={DeliveryIco} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }

                    case 'FloridaConnect': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={TabletFloridaConnect} alt="icon" width="26" />,
                                category: objright.category,
                                children: [
                                    { label: "Request", link: "/app/floridaConnect/request", icon: <img src={UsageReport} alt='icon' /> },
                                    { label: "Rejected", link: "/app/floridaConnect/rejected", icon: <img src={RejectedIcon} alt='icon' /> },
                                    { label: "Delivered", link: "/app/floridaConnect/delivered", icon: <img src={DeliveryIco} alt='icon' /> },
                                    { label: "Applicant logs", link: "/app/floridaConnect/applicants", icon: <img src={UsageReport} alt='icon' /> },

                                ],
                            });
                        }
                        break;
                    }

                    case 'FloridaRepresentative': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={TabletFloridaConnect} alt="icon" width="26" />,
                                category: objright.category,
                                isOpen: true,
                                children: [
                                    { label: "Request", link: "/app/FloridaRepresentative", icon: <img src={UsageReport} alt='icon' /> },
                                    { label: "Rejected", link: "/app/floridaConnect-representative/rejected", icon: <img src={RejectedIcon} alt='icon' /> },
                                    { label: "Delivered", link: "/app/floridaConnect-representative/delivered", icon: <img src={DeliveryIco} alt='icon' /> },

                                ],
                            });
                        }
                        break;
                    }

                    case 'PompanoBeach': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <TabletAndroidIcon style={{ color: "white" }} />,
                                category: objright.category,
                                children: [
                                    { label: "Request", link: "/app/pompanoBeach/request", icon: <img src={UsageReport} alt='icon' /> },
                                    { label: "Rejected", link: "/app/pompanoBeach/rejected", icon: <img src={RejectedIcon} alt='icon' /> },
                                    { label: "Delivered", link: "/app/pompanoBeach/delivered", icon: <img src={DeliveryIco} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }

                    // case 'FloridaConnect': {

                    //     if (sideBarLinks.label != objright.rightName) {

                    //     }
                    //     break;
                    // }
                    case 'EventsCalendar': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <DateRangeIcon />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'Grants': {

                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DashboardGrantIcon} alt='icon' width="26" />,
                                category: objright.category,
                                children: [
                                    { label: "Dashboard", link: "/app/grants/grandDashboard", icon: <img src={GrantDashboardIcon} alt='icon' /> },
                                    { label: "Program", link: "/app/grants/program", icon: <img src={GrantProgramIcon} alt='icon' /> },
                                    { label: "Donor", link: "/app/grants/organizations", icon: <img src={GrantOrganizationIcon} alt='icon' /> },
                                    { label: "Disbursement", link: "/app/grants/disbursement", icon: <img src={GrantDisbursementIcon} alt='icon' /> },

                                ],
                            });
                        }
                        break;
                    }
                    case 'chat': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: 'https://livechat.figgersfoundation.org/index.php/site_admin/user/login',
                                icon: <ForumIcon />,
                                category: objright.category,
                                //onClick: () => handleLinkClick('https://livechat.figgersfoundation.org/index.php/site_admin/user/login')
                            });
                        }
                        break;
                    }
                    case 'NewsMedia': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={AgencyListIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'LetterofSupport': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={PressReleaseIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'AgencyList': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={AgencyListIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'DistributerList': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={DistributionListIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }

                    case 'PressRelease': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <img src={PressReleaseIcon} alt='icon' />,
                                category: objright.category,
                            });
                        }
                        break;
                    }
                    case 'subscribers': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "/app/" + objright.rightName.toLowerCase(),
                                icon: <GroupAddIcon />,
                                category: objright.category,
                            });
                        }
                        break;
                    }

                    case 'NewsAndBlog': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: 9999,
                                label: "News & Blog",
                                link: "/app/add-post-blog",
                                icon: <img src={PressReleaseIcon} alt='icon' />,
                                category: "custom",
                            });
                        }
                        break;
                    }



                    case 'Setup': {
                        if (sideBarLinks.label != objright.rightName) {
                            sideBarLinks.push({
                                id: parseInt(objright.rightId),
                                label: objright.rightLabel,
                                link: "",
                                icon: <img src={Settingwhite} alt='setting' />,
                                category: objright.category,
                                children: [
                                    { label: "Roles", link: "/app/roles", rightCode: "setup_roles", icon: <img src={RolesIcon} alt='icon' /> },
                                    { label: "Users", link: "/app/users", rightCode: "setup_users", icon: <img src={UsersIcon} alt='icon' /> },
                                    { label: "Rights", link: "/app/rights", rightCode: "setup_rights", icon: <img src={UsersIcon} alt='icon' /> },
                                    { label: "Configuration", link: "/app/sysconfig", rightCode: "sys_config", icon: <img src={UsersIcon} alt='icon' /> },
                                ],
                            });
                        }
                        break;
                    }



                    default:
                        break;
                }
            }
        });




        // Manually inject "Add Post & Blog" sidebar item


        // routes.push({
        //     rightName: "AddPostAndBlog",
        //     permissionCode: 1,
        //     rightCode: "add_post_blog",
        //     landingPage: "add-post-blog",
        // });

    }
    return (
        <div className={classes.root}>
            {timerPoper ? (
                <IdleTimerPoper
                    handleOpen={timerPoperOpen}
                    handleClose={timerPoperClose}
                    logout={logoutUser}
                ></IdleTimerPoper>
            ) : (
                ""
            )}

            <Idletimer timeout={60000 * 15} onIdle={() => idleTimeOut()} />

            <AppBar
                position="absolute"
                className={clsx(classes.appBar, open && classes.appBarShift)}
            >
                <Toolbar className={classes.toolbar}>
                    {open ? (
                        <div className={classes.toolbarIcon}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerClose}
                                className={classes.menuButton}
                            >
                                <MenuIcon />
                            </IconButton>
                        </div>
                    ) : (
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}

                    <div className={classes.rightContent}>
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item className={classes.DropdownItems}>
                                        <NavLink to="/app/profile">
                                            <img
                                                className={classes.profileNavigationIco}
                                                src={UserPlaceholder}
                                                alt=""
                                            />{" "}
                                            Profile
                                        </NavLink>
                                    </Menu.Item>


                                    <Menu.Item className={classes.dropdownItems}>
                                        <NavLink to="/updatePassword" className={classes.changePassword}>
                                            <LockIcon />

                                            Change Password
                                        </NavLink>
                                    </Menu.Item>

                                    <Menu.Item
                                        onClick={() => logoutUser()}
                                        className={classes.dropdownItems}
                                    >
                                        {" "}
                                        <PowerSettingsNewIcon /> Logout
                                    </Menu.Item>

                                </Menu>
                            }
                            trigger={["click"]}
                            className={classes.actionDropDown}
                        >
                            <Button className={classes.profileDropper}>
                                <img
                                    className="user-profile"
                                    src={userdata != null ? "." + userdata.userPhotoPath : ""}
                                    alt=""
                                ></img>
                                <h4>
                                    {userdata != null
                                        ? userdata.firstName +
                                        (userdata.middleName && userdata.middleName.length > 0
                                            ? " " + userdata.middleName + " "
                                            : " ") +
                                        userdata.lastName
                                        : ""}
                                </h4>
                                <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>
                </Toolbar>
            </AppBar>

            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(
                        classes.drawerPaper,
                        !open ? classes.drawerPaperClose : ""
                    ),
                }}
                open={open}
            >
                <div className={open ? classes.logo : classes.logoSm}>
                    {open ? (
                        <img
                            onClick={() => HomeHistory.push("/app/" + (routes[0]?.landingPage ? routes[0]?.landingPage : "dashboard"))}
                            src={Logo}
                            alt=""
                        />
                    ) : (
                        <img
                            onClick={() => HomeHistory.push("/app/" + (routes[0]?.landingPage ? routes[0]?.landingPage : "dashboard"))}
                            width="34px"
                            src={LogoSm}
                            alt=""
                        />
                    )}
                </div>

                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.menuList}
                >
                    {sideBarLinks.map((link, index) => (

                        <div className={menusState.some(item => item.value && item.name === link.label) && link.children ? classes.openHasSubmenu : classes.hasSubmenu}>

                            <Tooltip title={open ? '' : link.label} placement="right" className={''}>
                                <ListItem onClick={open ? () => handleClickMenu(link.label) : (e) => handlePopoverOpen1(e, index)}>
                                    {link.children ? (
                                        <div className={classes.subMenuHead}>
                                            {link.icon} <span className={classes.MenuLabel}>{link.label} {link.children ? (
                                                <>
                                                    {menusState.some((item) => item.value && item.name === link.label) ? <ExpandLess /> : <ExpandMore />}
                                                </>
                                            ) : ''} </span>
                                        </div>
                                    ) : (
                                        <>
                                            {link.label == 'Chat' ?
                                                <a rel="noopener noreferrer" href="https://livechat.figgersfoundation.org/index.php/site_admin/user/login" target="_blank"><ForumIcon /> <span className={classes.MenuLabel}>  {link.label}</span></a>
                                                : <NavLink to={link.link} >
                                                    {link.icon} <span className={classes.MenuLabel}>{link.label}</span>
                                                </NavLink>}

                                        </>
                                    )}
                                </ListItem>
                            </Tooltip>
                            {open && link.children ?
                                <Collapse in={menusState.some(item => item.value && item.name === link.label)} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {link.children.filter(child => !hiddenChildren.includes(child.rightCode)).map(child => (
                                            <>
                                                <ListItem className={`${classes.nested} ${disabledChildren.includes(child.rightCode) ? ' disabledEvent' : ''}`}>
                                                    {child.label !== "International" ? <>
                                                        <NavLink to={child.link} >{child.icon} <span className={classes.MenuLabel}> {child.label}</span></NavLink>
                                                    </> : <>
                                                        <a rel="noopener noreferrer" href="https://www.dhl.com/pk-en/home.html?locale=true" target="_blank"><img src={InternationalTracking} /> <span className={classes.MenuLabel}>  International</span></a></>
                                                    }
                                                </ListItem>

                                            </>
                                        ))}

                                    </List>
                                </Collapse> :
                                link.children && link.children.length > 0 ?
                                    <>
                                        <div className={classes.menuPoper}>
                                            <Popover
                                                id={id}
                                                open={isPopoverOpen1 && popoverState == index}
                                                anchorEl={anchorE1}
                                                onClose={handlePopoverClose1}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'center',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List component="div" disablePadding>
                                                    {link.children.filter(child => !hiddenChildren.includes(child.rightCode)).map(child => (
                                                        <ListItem className={`${classes.popperSub} ${disabledChildren.includes(child.rightCode) ? ' disabledEvent' : ''}`}>
                                                            <NavLink to={child.link}>{child.icon} <span className={classes.MenuLabel}>{child.label}</span></NavLink>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Popover>
                                        </div>
                                    </> :
                                    ''
                            }
                        </div>
                    ))}
                </List>
            </Drawer>

            <main className="theme-container">
                <Suspense
                    fallback={
                        <Box
                            style={{
                                display: "block",
                                width: "100%",
                                textAlign: "center",
                                paddingTop: "10%",
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Switch>
                        <Route exact path="/" render={() => <Redirect to={"/app/" + routes[0]?.landingPage ? routes[0]?.landingPage : 'dashboard'} />} />

                        <Route exact path="/app" render={() => <Redirect to={"/app/" + routes[0]?.landingPage ? routes[0]?.landingPage : 'dashboard'} />} />

                        {routes.some(route => route.rightCode === 'dashboard') && (
                            <Route
                                path="/app/dashboard"
                                render={() => {
                                    const dashboardRoute = routes.find(route => route.rightCode === 'dashboard');
                                    return <Dashboard accessableRouts={routes} />;
                                }}
                            />
                        )}
                        {routes.some(route => route.rightCode === 'domesticTracking') && <Route path="/app/domesticTracking" render={() => <DomesticTracking trackingType={'domesticTracking'} />} />}
                        {routes.some(route => route.rightCode === 'domesticTracking') && <Route path="/app/internationalTracking" render={() => <DomesticTracking trackingType={'internationalTracking'} />} />}
                        {routes.some(route => route.rightCode === 'returnLabel') && <Route path="/app/returnLabel" render={() => <DomesticTracking trackingType={'returnLabel'} />} />}
                        {routes.some(route => route.rightCode === 'domesticTracking') && <Route path="/app/voiceCallLogs" component={VoiceCallLogs} />}
                        {routes.some(route => route.rightCode === 'all_donations') && <Route path="/app/donations" component={DonationDetails} />}
                        {routes.some(route => route.rightCode === 'all_donationRequest') && <Route path="/app/donationRequest" component={DonationRequest} />}
                        {routes.some(route => route.rightCode === 'addressbook') && <Route path="/app/addressbook" component={AddressBookPage} />}
                        {routes.some(route => route.rightCode === 'request') &&
                            <Route
                                path="/app/sheila/request"
                                render={() => <SheilaTablets applicationType={"requests"} />}
                            />}
                        {routes.some(route => route.rightCode === 'enrolled') &&
                            <Route
                                path="/app/sheila/enrolled"
                                render={() => <SheilaTablets applicationType={"enrolled"} />}
                            />}
                        {routes.some(route => route.rightCode === 'rejected') &&
                            <Route
                                path="/app/sheila/rejected"
                                render={() => <SheilaTablets applicationType={"rejected"} />}
                            />}
                        {routes.some(route => route.rightCode === 'delivered') &&
                            <Route
                                path="/app/sheila/delivered"
                                render={() => <SheilaTablets applicationType={"delivered"} />}
                            />
                        }



                        {routes.some(route => route.rightCode === 'requestPompanoBeach') &&
                            <Route
                                path="/app/pompanoBeach/request"
                                key="requests"
                                render={() => <PompanoBeach applicationType={"requests"} />}
                            />}
                        {routes.some(route => route.rightCode === 'rejectedPompanoBeach') &&
                            <Route
                                path="/app/pompanoBeach/rejected"
                                key="rejected"
                                render={() => <PompanoBeach applicationType={"rejected"} />}
                            />}
                        {routes.some(route => route.rightCode === 'deliveredPompanoBeach') &&
                            <Route
                                path="/app/pompanoBeach/delivered"
                                key="delivered"
                                render={() => <PompanoBeach applicationType={"delivered"} />}
                            />
                        }


                        {routes.some(route => route.rightCode === 'requestFloridaConnect') &&
                            <Route
                                path="/app/floridaConnect/request"
                                key="requests"
                                render={() => <FloridaConnect applicationType={"requests"} />}
                            />}
                        {routes.some(route => route.rightCode === 'rejectedFloridaConnect') &&
                            <Route
                                path="/app/floridaConnect/rejected"
                                key="rejected"
                                render={() => <FloridaConnect applicationType={"rejected"} />}
                            />}
                        {routes.some(route => route.rightCode === 'FloridaConnect') &&
                            <Route
                                path="/app/floridaConnect/delivered"
                                key="delivered"
                                render={() => <FloridaConnect applicationType={"delivered"} />}
                            />
                        }

                        {routes.some(route => route.rightCode === 'FloridaConnect') &&
                            <Route
                                path="/app/floridaConnect/applicants"
                                key="delivered"
                                render={() => <FloridaConnectApplicant />}
                            />
                        }

                        {routes.some(route => route.rightCode === 'FloridaRepresentative') &&
                            <Route
                                path="/app/FloridaRepresentative"
                                key="requests"
                                render={() => <FloridaConnectRepresentative applicationType={"requests"} />}
                            />}
                        {routes.some(route => route.rightCode === 'FloridaRepresentative') &&
                            <Route
                                path="/app/floridaConnect-representative/rejected"
                                key="rejected"
                                render={() => <FloridaConnectRepresentative applicationType={"rejected"} />}
                            />}
                        {routes.some(route => route.rightCode === 'FloridaRepresentative') &&
                            <Route
                                path="/app/floridaConnect-representative/delivered"
                                key="delivered"
                                render={() => <FloridaConnectRepresentative applicationType={"delivered"} />}
                            />
                        }



                        {routes.some(route => route.rightCode === 'requestPalmBeach') &&
                            <Route
                                path="/app/palmBeach/request"
                                key="requests"
                                render={() => <PalmBeachTablets applicationType={"requests"} />}
                            />}
                        {routes.some(route => route.rightCode === 'rejectedPalmBeach') &&
                            <Route
                                path="/app/palmBeach/rejected"
                                key="rejected"
                                render={() => <PalmBeachTablets applicationType={"rejected"} />}
                            />}
                        {routes.some(route => route.rightCode === 'deliveredPalmBeach') &&
                            <Route
                                path="/app/palmBeach/delivered"
                                key="delivered"
                                render={() => <PalmBeachTablets applicationType={"delivered"} />}
                            />
                        }


                        {routes.some(route => route.rightCode === 'program') &&

                            <Route
                                path="/app/grants/program"
                                render={() => <GrantProgram applicationType={"program"} />}
                            />

                        }
                        {routes.some(route => route.rightCode === 'grants_dashboard') &&
                            <Route
                                path="/app/grants/grandDashboard"
                                render={() => <GrantDashboard applicationType={"dashboard"} />}
                            />
                        }
                        {routes.some(route => route.rightCode === 'organizations') &&
                            <Route
                                path="/app/grants/organizations"
                                render={() => <Organizations applicationType={"organizations"} />}
                            />
                        }
                        {routes.some(route => route.rightCode === 'disbursement') &&
                            <Route
                                path="/app/grants/disbursement"
                                render={() => <Disbursement applicationType={"disbursement"} />}
                            />
                        }
                        {routes.some(route => route.rightCode === 'FeedingFamily') &&
                            <Route path="/app/feedingfamily" component={FeedingFamily} />
                        }
                        {routes.some(route => route.rightCode === 'reviews') &&
                            <Route path="/app/reviews" component={Reviews} />
                        }

                        <Route path="/app/profile" component={Profile} />

                        {routes.some(route => route.rightCode === 'EventsCalendar') &&
                            <Route path="/app/EventsCalendar" component={EventsCalendar} />
                        }

                        <Route path="/app/updatePassword" component={UpdatePassword} />

                        {routes.some(route => route.rightCode === 'NewsMedia') &&
                            <Route path="/app/NewsMedia" component={NewsMedia} />
                        }
                        {routes.some(route => route.rightCode === 'LetterofSupport') &&
                            <Route path="/app/LetterofSupport" component={LetterofSupport} />
                        }
                        {routes.some(route => route.rightCode === 'PressRelease') &&
                            <Route path="/app/PressRelease" component={PressRelease} />
                        }
                        {routes.some(route => route.rightCode === 'AgencyList') &&
                            <Route path="/app/AgencyList" component={AgencyList} />
                        }
                        {routes.some(route => route.rightCode === 'DistributerList') &&
                            <Route path="/app/DistributerList" component={DistributerList} />
                        }
                        {routes.some(route => route.rightCode === 'chat') &&
                            <Route path="/app/Chat" component={Chat} />
                        }
                        {routes.some(route => route.rightCode === 'setup_roles') &&
                            <Route
                                path="/app/roles"
                                render={() => <Roles />}
                            />}
                        {routes.some(route => route.rightCode === 'setup_users') &&
                            <Route
                                path="/app/users"
                                render={() => <Users />}
                            />}

                        <Route path="/app/rights" component={Rights} />




                        {routes.some(route => route.rightCode === 'sys_config') &&
                            <Route
                                path="/app/sysconfig"
                                render={() => <SysConfig />}
                            />}
                        {routes.some(route => route.rightCode === 'ecc_applications') &&
                            <Route
                                path="/app/christmas/applications"
                                render={() => <EveryChildChristmas />}
                            />}
                        {routes.some(route => route.rightCode === 'subscribers') &&
                            <Route path="/app/subscribers" component={Subscribers} />}
                        {routes.some(route => route.rightCode === 'ecc_donations') &&
                            <Route
                                path="/app/christmas/donations"
                                render={() => <ECCDonations />}
                            />}

                        {routes.some(route => route.rightCode === 'socialWorker') &&

                            <Route path="/app/socialworker"
                                render={() => <SocialWorker />} />}

                        <Route path="/app/add-post-blog" component={AddPostAndBlogPage} />


                    </Switch>
                </Suspense>
            </main>

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
        </div>
    );
}
